import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import { auditReducer, authReducer, commonReducer, customerReducer, dashboardReducer, userReducer, formsReducer } from './slices';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['common'],
};

const rootReducer = combineReducers({
  common: commonReducer,
  user: userReducer,
  auth: authReducer,
  customer: customerReducer,
  dashboard: dashboardReducer,
  audit: auditReducer,
  forms: formsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
export default store;
